// Famille d'un fichier d'après son extension : couleur et icône dans le gestionnaire de documents
const TYPES = {
    pdf: ['pdf'],
    img: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'heic', 'tif', 'tiff'],
    xls: ['xls', 'xlsx', 'xlsm', 'csv', 'ods'],
    doc: ['doc', 'docx', 'odt', 'rtf', 'txt'],
    ppt: ['ppt', 'pptx', 'odp'],
    zip: ['zip', 'rar', '7z', 'gz', 'tar'],
    video: ['mp4', 'webm', 'mov', 'm4v', 'ogv'],
    audio: ['mp3', 'wav', 'ogg', 'm4a', 'aac'],
};

const ICONS = {
    pdf: 'fa-file-pdf',
    img: 'fa-file-image',
    xls: 'fa-file-excel',
    doc: 'fa-file-word',
    ppt: 'fa-file-powerpoint',
    zip: 'fa-file-archive',
    video: 'fa-file-video',
    audio: 'fa-file-audio',
    other: 'fa-file',
};

export function fileType(extension) {
    const ext = (extension || '').toLowerCase();
    return Object.keys(TYPES).find(type => TYPES[type].includes(ext)) || 'other';
}

export function fileIcon(extension) {
    return ICONS[fileType(extension)];
}
